import { MyProfileForm } from '../components/molecules/profile/MyProfileForm'

interface ProfileSetupProps {
	email: string
	onSignOut: () => void
}

export default function ProfileSetup({ email, onSignOut }: ProfileSetupProps) {
	return (
		<div className="min-h-screen bg-background px-4 pt-safe pb-safe">
			<div className="mx-auto flex w-full max-w-lg flex-col gap-6 py-8">
				<div className="flex flex-col gap-1">
					<span className="text-xs font-medium tracking-wider text-muted-foreground">SAYSAY</span>
					<h1 className="text-xl font-medium text-foreground">Welcome to the team</h1>
					<p className="text-sm text-muted-foreground">What should we call you? Everyone in the app sees this name.</p>
				</div>
				<MyProfileForm fields={['name']} submitLabel="Continue" />
				<p className="text-center text-xs text-muted-foreground">
					Signed in as {email}.{' '}
					<button type="button" onClick={onSignOut} className="text-primary underline-offset-2 hover:underline">
						Log out
					</button>
				</p>
			</div>
		</div>
	)
}
